const MeasureUnits = Object.freeze({
    KG: { value: 'KG', label: 'Quilo' },
    FD: { value: 'FD', label: 'Fardo' },
    SC: { value: 'SC', label: 'Saca' },
});
export default MeasureUnits;

export const getMeasureUnitLabel = (value) => {
  const unit = Object.values(MeasureUnits).find((unit) => unit.value === value);
  return unit ? unit.label : value;
};